import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const ReferencesPerEntryPointAndLicenseBarChart = ({ data, isLoading }) => {
  const colors = [
    "rgba(54, 162, 235, 0.6)", // Blue
    "rgba(75, 192, 192, 0.6)", // Light Blue
    "rgba(255, 205, 86, 0.6)", // Yellow
    "rgba(255, 159, 64, 0.6)", // Orange
    "rgba(255, 99, 132, 0.6)", // Red
    "rgba(153, 102, 255, 0.6)", // Purple
    "rgba(201, 203, 207, 0.6)", // Grey
  ];

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    if (isLoading || !data || data.length === 0) {
      return;
    }

    const processData = () => {
      const entryPointLicenseCounts = {};
      data.forEach((item) => {
        const entryPoint = item.header.pedimento.pedimento_entry_point;
        const license = item.header.pedimento.pedimento_license;
        if (!entryPointLicenseCounts[entryPoint]) {
          entryPointLicenseCounts[entryPoint] = {};
        }
        entryPointLicenseCounts[entryPoint][license] =
          (entryPointLicenseCounts[entryPoint][license] || 0) + 1;
      });

      const entryPoints = Object.keys(entryPointLicenseCounts);
      const licenses = Array.from(
        new Set(data.map((item) => item.header.pedimento.pedimento_license))
      );

      const datasets = licenses.map((license, index) => ({
        label: license,
        data: entryPoints.map(
          (entryPoint) => entryPointLicenseCounts[entryPoint][license] || 0
        ),
        backgroundColor: colors[index % colors.length],
      }));

      setChartData({
        labels: entryPoints,
        datasets: datasets,
      });
    };

    processData();
  }, [data, isLoading]);

  const options = {
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
      },
      x: {
        stacked: true,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
      datalabels: {
        color: "#fff",
        display: true,
        formatter: (value) => (value > 0 ? value : ""),
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          References per Entry Point and License
        </h2>
      </div>
      <div className="flex-grow relative">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <FontAwesomeIcon
              icon={faSpinner}
              className="animate-spin text-xl"
            />
            <span className="ml-2 text-lg">Loading...</span>
          </div>
        ) : (
          <Bar data={chartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default ReferencesPerEntryPointAndLicenseBarChart;
